// extracted by mini-css-extract-plugin
export default {"sliderContainer":"_11ekH___Triptych-module__sliderContainer"};